export const ACTIVATE_OVERLAY = "ACTIVATE_OVERLAY";
export const DEACTIVATE_OVERLAY = "DEACTIVATE_OVERLAY";



// WEBPACK FOOTER //
// ./src/services/ui/overlay/types.js